import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setReferringUSNG } from '../store/pickupAddress.actions'
import { LLtoUSNGwrapper } from '../../../utilities'
import { PickupAddressConstants } from '../store/pickupAddress.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* calculateReferringUSNG(referringGPSN: string, referringGPSE: string) {
  const gpsn_pattern = new RegExp('^((\\+|-)?(90(\\.[0]{1,6})?|([1-8][0-9]|[0-9])(\\.[0-9]{1,6})?))$')
  const gpse_pattern = new RegExp('^((\\+|-)?(180(\\.[0]{1,6})?|(1[0-7][0-9]|[1-9][0-9]|[0-9])(\\.[0-9]{1,6})?))$')
  if (
    referringGPSN !== '' &&
    referringGPSE !== '' &&
    gpsn_pattern.test(referringGPSN) &&
    gpse_pattern.test(referringGPSE)
  ) {
    const usng = LLtoUSNGwrapper(parseFloat(referringGPSN.toString()), parseFloat(referringGPSE.toString()), 4)
    return usng
  }
}

export function* setCalculateReferringUSNG() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pickupAddress = pcrDoc.patient?.pickupAddress
      if (pickupAddress && Object.keys(pickupAddress).length !== 0) {
        const usng: string = yield call(
          calculateReferringUSNG,
          pickupAddress.referringGPSN,
          pickupAddress.referringGPSE
        )
        if (usng) {
          yield put(setReferringUSNG(usng))
        }
      }
    } catch (e) {
      yield put(throwPcrException(`setCalculateReferringUSNG() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCalculateReferringUSNGSaga() {
  yield takeLatest([PickupAddressConstants.CALCULATE_REFERRING_USNG], performWithMutexHOG, setCalculateReferringUSNG)
}
